module.exports = __webpack_public_path__ + "static/media/notificationAssessment.8dbdfc07.mp3";